<template>
  <div class="usage-term-personalize-form-preview-container"
      :class="{'color-picker_active': showColorPickerCanva}">

    <canvas :class="{ 'active': showColorPickerCanva }"
            ref="canvas"
            @mousemove="getColor"
            @mouseover="setHover"
            @mouseout="unsetHover"
            @click="setColor">
    </canvas>

    <div class="usage-terms-personalize-form-preview-main"
         ref="captiveScreen"
         :style="{ background: bg }">
      <div class="container">
        <div class="usage-terms-personalize-form-preview-main-header">
          <img :src="logoRef" />
        </div>
  
        <div class="usage-terms-personalize-form-preview-main-text"
             v-html="config.phraseLogin"
             :style="{ color: textColor }"></div>
  
        <div class="usage-terms-personalize-form-preview-main-actions">
          <!-- <button v-if="hasLinkedinLogin"
                  class="btn btn-block  usage-terms-personalize-form-preview-main-actions-item usage-terms-personalize-form-preview-main-actions-item_linkedin">
            <img class="usage-terms-personalize-form-preview-main-actions-item-img"
                 src="/images/linkedin.png"
                 alt="linkedin-logo" />
            <span>{{$t('message.loginPersonalize.message.loginWithLinkedin')}}</span>
          </button>
  
          <button v-if="hasFacebookLogin"
                  class="btn btn-block  usage-terms-personalize-form-preview-main-actions-item usage-terms-personalize-form-preview-main-actions-item_fb">
            <img class="usage-terms-personalize-form-preview-main-actions-item-img"
                 src="/images/facebook-logo.png"
                 alt="facebook-logo" />
            <span>{{$t('message.loginPersonalize.message.loginWithFacebook')}}</span>
          </button> -->
  
          <button class="btn btn-block  usage-terms-personalize-form-preview-main-actions-item usage-terms-personalize-form-preview-main-actions-item_email"
                  :style="{ color: textColor, borderColor: textColor }">
            <i class="usage-terms-personalize-form-preview-main-actions-item-img mdi mdi-email" />
            <span>{{$t('message.loginPersonalize.message.loginWithEmail')}}</span>
          </button>
        </div>
  
        <div class="usage-terms-personalize-form-preview-main-footer"
             :style="{ color: textColor }">
          <div class="usage-terms-personalize-form-preview-main-footer-text">{{$t('message.loginPersonalize.message.byRegistering')}} <strong>{{$t('message.loginPersonalize.message.termsOfUse')}}</strong></div>
          <div class="usage-terms-personalize-form-preview-main-footer-login">{{$t('message.loginPersonalize.message.alreadyRegistered')}} <strong>{{$t('message.loginPersonalize.message.login')}}</strong></div>
        </div>
  
      </div>
    </div>

    <div id="color-preview"
         :class="hovering ? 'active' : ''"
         :ref="myUniqueId"
         :style="{ background: colorPreviewColor }">
    </div>

    <div v-if="loading"
         class="loading-cover"
         ref="loadingCover">
      <SyncLoader class="custom-class"
                  color="#e6e6e6"
                  :loading="loading" />

    </div>
  </div>
</template>

<script>
import { SyncLoader } from "@saeris/vue-spinners";
import colorPicker from "@mixins/colorPicker";

export default {
  components: {
    SyncLoader
  },

  props: {
    config: {
      type: Object,
    },
    temporaryImage: {
      type: String
    },
    temporaryLogo: {
      type: String
    },
    
  },

  data() {
    return {
      entity: 'captiveStyle'
    };
  },

  watch: {
    config: {
      deep: true,
      handler(newConfig, oldConfig) {

        if(newConfig.registerBackground) {
          if( newConfig.registerBackground !== oldConfig.registerBackground)          
           this.bg = `url(${process.env.VUE_APP_BACK_END_URL}/file/public/background/${this.config.registerBackground})`          
        } else {
          this.bg = newConfig.registerStyle.bg
        }
      },
    },    
  },

  computed: {   
    textColor() {
      return this.config.registerStyle.text;
    },    
    logoRef() {     
      return this.temporaryLogo ?
             this.temporaryLogo:
             this.config.logo ? this.config.logo : 
             this.config.isDefaultGreen ? "/images/logo.png" : "/images/logo-white.png"

    },
    bg: {
      get() {
        return this.temporaryImage ? `url(${this.temporaryImage})` :
              this.config.registerBackground ?
             `url(${process.env.VUE_APP_BACK_END_URL}/file/public/background/${this.config.registerBackground}?rnd=${this.cacheKey})` :             
             this.config.registerStyle.bg
      },
      set() {
        return
      }
    },    
  },

  methods: {},

  mounted() {},

  mixins: [colorPicker]
 
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.usage-term-personalize-form-preview-container {
  position: relative;

  .loading-cover {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    border-radius: 5px;
    background: rgba($color: #000000, $alpha: 0.3);
  }

  canvas {
    display: none;

    cursor: pointer;    

    &.active {
      display: block;
    }
  }

  .usage-terms-personalize-form-preview-main {
    width: 300px;
    height: 500px;
    border: 1px solid black;
    border-radius: 25px;
    background: linear-gradient(0deg, #092f39, #497461);
    background-size: cover !important;
    background-position: center !important;
  
    .container {
      height: 100%;
      display: flex;
      flex-direction: column;
  
      .usage-terms-personalize-form-preview-main-header {
        margin-bottom: 50px;
  
        img {
          display: block;
          margin: 0 auto;
          max-height: 75px;
          max-width: 100%;
        }
      }
  
      .usage-terms-personalize-form-preview-main-text {
        color: white;
        font-size: 18px;
        word-wrap: break-word;
        /* max-height: 195px;
        overflow-y: hidden; */
      }
  
      .usage-terms-personalize-form-preview-main-actions {
        margin-top: auto;
        margin-bottom: 15px;
  
        .usage-terms-personalize-form-preview-main-actions-item {
          width: 100%;
          color: white;
          text-align: center;
          font-weight: 600;
          border-radius: 24px;
          font-size: 10px;
          position: relative;
          height: 48px;
          text-transform: uppercase;
  
          .usage-terms-personalize-form-preview-main-actions-item-img {
            position: absolute;
            width: 12px;
            left: 20px;
            top: 50%;
            transform: translateY(-50%);
          }
  
          &.usage-terms-personalize-form-preview-main-actions-item_fb {
            background: $facebook-color;
            margin-bottom: 10px;
          }
  
          &.usage-terms-personalize-form-preview-main-actions-item_linkedin {
            background: $linkedin-color;
            margin-bottom: 10px;
          }
  
          &.usage-terms-personalize-form-preview-main-actions-item_email {
            border: 2px solid white;
  
            .usage-terms-personalize-form-preview-main-actions-item-img {
              font-size: 20px;
              left: 15px;
            }
          }
        }
      }
  
      .usage-terms-personalize-form-preview-main-footer {
        color: white;
        text-align: center;
  
        .usage-terms-personalize-form-preview-main-footer-text {
          font-size: 8px;
          margin-bottom: 10px;
        }
  
        .usage-terms-personalize-form-preview-main-footer-login {
          font-size: 13px;
        }
      }
    }
  }

  #color-preview {
    display: none;
    position: fixed;
    z-index: 1000;
    width: 10px;
    height: 10px;
    border: 1px solid white;

    &.active {
      display: block;
    }
  }

  &.color-picker_active {
    .usage-terms-personalize-form-preview-main {
      display: none;
    }
  }
}

</style>
